import React from 'react';
import { withCookies } from 'react-cookie';
import { withRouter } from 'react-router-dom';

import { Container, Typography, Paper, Button } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';

import { GenericTextField } from 'form-builder';

import { DocumentUploaderDownloaderComponent } from '../components/DocumentUploaderDownloaderComponent';
import AGTheme from '../Theme';
import { Community } from '../models/Community';
import { Email } from 'react-frontend-utils';

export class Renew extends DocumentUploaderDownloaderComponent {

    _group;
    _submitTimer;
    _test;

    constructor(props) {
        super(props);

        this._group = props.group ? encodeURIComponent(props.group) : null;
        this._test = props.test;                                             //Arrives with the test key

        this.state.community = null;
        this.state.fetchComplete = false;
        this.state.fetchError = null;

        this.state.email = '';
        this.state.emailInvalid = false;
        this.state.submitTried = false;
        this.state.submitting = false;
        this.state.submitted = false;
    }

    componentWillUnmount() {
        if (this._submitTimer) {
            clearTimeout(this._submitTimer);
            this._submitTimer = null;
        }

        if (super.componentWillUnmount) {
            super.componentWillUnmount();
        }
    }

    componentDidMount() {
        super.componentDidMount();

        if (!this._group) {
            this.showConfirmAlert('No Community', 'You did not arrive with a link from your Community', 'red');
            this.setState({ fetchComplete: true });
            return;
        }

        this._fetchCommunityInfo();
    }

    _fetchCommunityInfo = () => {
        this.incrementBusy();

        let queryString = '?group=' + this._group;

        this.secureJSONFetch('/patron/groupinfo', {}, this._fetchStatusCallback, this._fetchErrorCallback, queryString);
    }

    _fetchStatusCallback = (response) => {
        if (response)
            this.setState({ community: new Community(response), fetchComplete: true, fetchError: null });

        this.decrementBusy();
    }

    _fetchErrorCallback = (error) => {
        this.decrementBusy();
        this.setState({ fetchComplete: true, fetchError: error, community: null });
    }

    _emailChanged = (userValue) => {
        if (userValue && !Email.validateEmail(userValue)) {
            this.showConfirmAlert('Error', 'Email "' + userValue + '" address not valid', 'red');
            this.setState({ email: userValue, emailInvalid: true });
            return;
        }

        this.setState({ email: userValue, emailInvalid: false });
    }

    _submitRenewal = () => {
        if (!this.state.email || this.state.emailInvalid) {
            this.showConfirmAlert('Invalid Email', 'Email is missing or invalid.', 'red');
            this.setState({ submitTried: true });
            return;
        }

        this.incrementBusy();
        this.setState({ submitting: true, submitTried: true });

        let queryString = '?group=' + this._group + '&email=' + encodeURIComponent(this.state.email);
        if (this._test)
            queryString += "&test=" + this._test;

        this._submitTimer = setTimeout(() => {
            this._submitTimer = null;
            this.secureJSONFetch('/patron/renew', { method: 'POST' }, this._submitComplete, this._submitErrorCallback, queryString);
        }, 5000);
    }

    _submitComplete = () => {
        this.decrementBusy();
        this.setState({ submitting: false, submitted: true });
    }

    _submitErrorCallback = (error) => {
        this.showConfirmAlert('Error', error, 'red');
        this.decrementBusy();
        this.setState({ submitting: false });
    }


    render() {
        const community = this.state.community;
        const themeColor = community && community.primaryColor ? community.primaryColor : 'black';
        const backgroundColor = community && community.backgroundColor ? community.backgroundColor : 'white';
        const status = community ? community.status() : null;

        const emailBorder = ((this.state.submitTried && !this.state.email) || this.state.emailInvalid)
            ? { border: '1px solid red', padding: 3, paddingTop: 8 }
            : { border: 'none', padding: 0 };

        const title = community ? (community.extendedName + ' Membership Renewal') : 'Membership Renewal';
        const canRenew = (status === Community.Status.ACCEPTING || this._test) && community && community.renewalEnabled;

        return (
            <ThemeProvider theme={AGTheme}>
                <div style={{ backgroundColor: backgroundColor, paddingBottom: 20 }}>
                    <Container disableGutters={true} style={{ padding: 10 }}>

                        <Typography variant="h4" align="center" style={{ color: themeColor, marginBottom: 20 }}>{title}</Typography>

                        {this.getConfirmAlertComponent()}

                        {this.state.fetchComplete && !community ? 
                            <Typography variant="h5" align="center" style={{ color: 'red' }}>{this.state.fetchError ? this.state.fetchError : 'Unable to retrieve Community'}</Typography>
                            : 
                            (canRenew ? (
                                <Paper elevation={3} style={{ padding: 15 }}>
                                    <Typography variant="body1" style={{ fontStyle: 'italic', marginLeft: 10 }}>
                                        Enter your email address to start your renewal.
                                    </Typography>

                                    <div style={{ ...emailBorder, marginTop: 10 }}>
                                        <GenericTextField label="Your Email Address *" idleTimeout={7000} onFieldChange={this._emailChanged}
                                        />
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20, marginBottom: 10 }}>
                                        <Button
                                            disabled={this.state.submitting || this.state.submitted || !community}
                                            variant="contained"
                                            color="primary"
                                            onClick={this._submitRenewal}
                                            style={{ opacity: this.state.submitted ? 0.5 : 1 }}
                                        >
                                            Submit
                                        </Button>
                                    </div>

                                    {this.state.submitted
                                        ? <Typography variant="h5" align="center" style={{ color: 'green', marginTop: 10 }}>
                                            Please check your email for further instructions
                                          </Typography>
                                        : null}
                                </Paper>
                            ) : (
                                <div>
                                    <Typography variant="h5" align="center" style={{ marginBottom: 20 }}>
                                        We are not currently accepting membership renewals.
                                    </Typography>
                                </div>
                            ))}

                        {this.state.isBusy ? this.getBusyComponent('center', { marginTop: 20 }) : <div style={{ height: 50 }} />}
                    </Container>
                </div>
            </ThemeProvider>
        );
    }
}

export default withCookies(withRouter(Renew));
